const CANONICAL_SUPPLIER_ID_ALIASES = Object.freeze({
  // The ASI-facing Stormtech USA record represents the importable Canadian
  // CoreSupplier that owns the OneSource service connections.
  "8992": "911202",
});

export const resolveCanonicalSupplierCoreId = supplier => {
  if (!supplier || typeof supplier !== "object") return null;
  const direct = supplier.CoreSupplierId ?? supplier.coreSupplierId ?? supplier.CatalogSupplierId ?? supplier.catalogSupplierId ??
    supplier.CoreSupplier?.Id ?? supplier.CoreSupplier?.id ?? supplier.Supplier?.Id ?? supplier.Supplier?.id;
  if (direct != null && String(direct).trim()) return direct;
  const references = Array.isArray(supplier.References) ? supplier.References : [];
  const canonicalReference = references.find(reference => String(reference?.source || "").toLowerCase() === "custom-core" &&
    (reference?.coreSupplierId ?? reference?.CoreSupplierId ?? reference?.supplierId ?? reference?.SupplierId) != null);
  const fallback = canonicalReference?.coreSupplierId ?? canonicalReference?.CoreSupplierId ?? canonicalReference?.supplierId ??
    canonicalReference?.SupplierId ?? supplier.Id ?? supplier.id ?? null;
  return CANONICAL_SUPPLIER_ID_ALIASES[String(fallback)] || fallback;
};
